import { useEffect, useState } from 'react';
import { BookmarkPlus, FileText, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import api from '@/lib/api';

export const LetterTemplatesMenu = ({ subject, bodyHtml, onApply }) => {
  const [templates, setTemplates] = useState([]);
  const [name, setName] = useState('');

  const load = () => api.get('/admin/letter-templates').then(({ data }) => setTemplates(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post('/admin/letter-templates', { name, subject, body_html: bodyHtml });
      toast.success(`Vorlage „${name}" gespeichert`);
      setName('');
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Vorlage konnte nicht gespeichert werden');
    }
  };

  const remove = async (t) => {
    if (!window.confirm(`Vorlage „${t.name}" löschen?`)) return;
    await api.delete(`/admin/letter-templates/${t.id}`);
    load();
  };

  return (
    <div className="space-y-3" data-testid="letter-templates">
      {templates.length === 0 && <p className="text-xs text-gray-500">Noch keine Vorlagen gespeichert.</p>}
      <div className="space-y-1">
        {templates.map((t) => (
          <div key={t.id} className="group flex items-center gap-1">
            <button type="button" onClick={() => onApply(t)} className="flex-1 flex items-center gap-2 text-left text-sm px-2 py-1.5 rounded hover:bg-[#9B1B30]/5 transition-colors min-w-0" data-testid={`letter-template-apply-${t.id}`}>
              <FileText className="w-3.5 h-3.5 text-[#9B1B30] shrink-0" />
              <span className="truncate">{t.name}</span>
            </button>
            <button type="button" onClick={() => remove(t)} className="p-1 text-gray-400 hover:text-red-600 opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`letter-template-delete-${t.id}`}>
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name der Vorlage" className="h-8 text-sm" data-testid="letter-template-name-input" />
        <Button size="sm" variant="outline" className="h-8 shrink-0" disabled={!name.trim() || !bodyHtml} onClick={save} title="Aktuellen Brief als Vorlage speichern" data-testid="letter-template-save-btn">
          <BookmarkPlus className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default LetterTemplatesMenu;
